export default __webpack_public_path__ + "static/media/md8-warehouse-material-handling.80bef57a.svg";